import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { mainSiteUrl, categories } from "@/mocks/categories";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-sm border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap"
          >
            <span className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              GTBuy<span className="text-accent-500">.PRO</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap"
            >
              GTBuy Sheet
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line ml-1.5"></i>
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70">
            <div className="max-h-[calc(100vh-64px)] overflow-y-auto py-4">
              <div className="flex flex-col gap-4">
                <div className="flex flex-col gap-2">
                  <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider px-2">
                    Quick Actions
                  </p>
                  <a
                    href={mainSiteUrl}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-3 text-sm text-foreground-700 hover:text-foreground-950 transition-colors px-3 py-2.5 rounded-lg hover:bg-background-100 whitespace-nowrap cursor-pointer"
                  >
                    <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                      <i className="ri-external-link-line text-sm"></i>
                    </span>
                    <span>GTBuy Sheet</span>
                  </a>
                  <a
                    href={mainSiteUrl}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-3 bg-primary-500 hover:bg-primary-600 text-background-50 px-4 py-2.5 rounded-full text-sm font-medium text-center transition-all whitespace-nowrap cursor-pointer"
                  >
                    <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/20">
                      <i className="ri-shopping-cart-2-line text-sm"></i>
                    </span>
                    <span>Buy It Now</span>
                    <i className="ri-arrow-right-up-line ml-auto"></i>
                  </a>
                </div>

                <div className="border-t border-background-200/70 pt-4">
                  <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider px-2 mb-2">
                    Shop by Category
                  </p>
                  <div className="grid grid-cols-2 gap-1 px-1">
                    {categories.map((cat) => (
                      <a
                        key={cat.name}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="flex items-center gap-2.5 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors px-3 py-2.5 rounded-lg whitespace-nowrap cursor-pointer"
                      >
                        <span className="w-6 h-6 flex items-center justify-center rounded-md bg-accent-100 text-accent-500 flex-shrink-0">
                          <i className={`${cat.icon} text-xs`}></i>
                        </span>
                        <span className="truncate">{cat.name}</span>
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}